export const TOAST_AUTOCLOSE_TIMEOUT_MS = 3000;
